export default [{
  path: '/aderencia-ais',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Aderência AIS Histórico',
      path: 'historico',
      component: () => import('@/views/aderenciaAis/Historico.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups'},
          { name: 'Aderência AIS' }
        ]
      },
    },
    {
      name: 'Aderência AIS Adicionar',
      path: 'edit',
      component: () => import('@/views/aderenciaAis/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups'},
          { name: 'Aderência AIS', path: '/aderencia-ais/historico' },
          { name: 'Adicionar' }
        ]
      },
    }
  ]
}]